import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { GetInvoicesThunk } from "../../../redux/thunks/GetInvoicesThunk";

const InvoicesHeader = () => {
    const dispatch = useDispatch();
    const invoices = useSelector(state => state.invoices);

    return (
        <>
            <input type="date"
                value={ invoices.date }
                onChange={ event => {
                    dispatch(GetInvoicesThunk({ date: event.target.value }));
                } }
            />
        </>
    );
};

export default InvoicesHeader;